<div>
<app-common-search-view [form]="form" header="Närvarostatistik per möte" (createReport)="createReport($event)" [showSpinner]="showSpinner" (clearReportView)="clearReport()" [multiple]="false">
</app-common-search-view>
</div>


<!--div *ngFor="let r of response;index as i">
  Year:{{r[i].year}}
  Datum: {{r[i].meetingDate | date: 'yyyy-MM-dd'}}
  Antal närvarande: {{r[i].memberAttendees.length}}
</div-->
<!--pre>{{response|json}}</pre-->
<br><br>
<div class="me-4 ms-4">

<div *ngIf="response && form.get('institutions').value.length > 0 && form.get('selectedFilter').value !== '4'" >
  <br>
  <p-menubar [model]="items">

  </p-menubar>
  <div>
  <span *ngFor="let y of years;index as idx">
  <div class="col-md-12" style="border-right:1px solid lightgrey;border-top:1px solid lightgrey;">
   <b style="font-size:16px;">{{y}}</b>
    <table>
      <tr>
        <th>Månad</th>
        <th>Datum</th>
        <th>Antal närvarande</th>
        <th>Antal medlemmar</th>
        <th>Närvaro %</th>
      </tr>

      <tr *ngFor="let m of response[idx]?.meetings">
        <td>{{m.month}}</td>
        <td><a [routerLink]="['/meetings/meetings/meetingdetails']" [queryParams]="{edit: false, id: m.meetingId}">{{m.meetingDate | date: 'yyyy-MM-dd'}}</a></td>
        <td align="center">{{m.memberAttendanceCount}}</td>
        <td align="center" *ngIf="m.totalMembers !== 0">{{m.totalMembers}}</td> <td *ngIf="m.totalMembers === 0"></td>
        <td align="right" *ngIf="m.attendancePercent !== 0">{{m.attendancePercent}}</td><td *ngIf="m.attendancePercent === 0"></td>
      </tr>
      <tr style="font-weight: bold;border-top:1px solid lightgrey;padding-top:5px;"><td>Totalt:</td><td></td><td align="center">{{response[idx]?.total.totalAmount}}</td><td></td><td align="right">{{response[idx]?.total.totalPercent}}</td></tr>
    </table>
  </div>
</span>
</div>
</div>


<div *ngIf="response && form.get('institutions').value.length === 0 || form.get('selectedFilter').value === '4'" class="me-2 ms-2">
  <p-menubar [model]="items">

  </p-menubar>
  <div class="row">
  <span *ngFor="let y of years;index as idx">
    <div class="col-md-12" style="border-right:1px solid lightgrey;border-top:1px solid lightgrey;">
      <b style="font-size:16px;">{{y}}</b>
      <table>
        <tr>
          <th>Nr</th><th>Institution</th><th>Totalt antal</th><th>Närvaro %</th>
        </tr>
        <tr *ngFor="let i of response[idx]?.meetings;index as idx2">
          <td>{{idx2 + 1}}</td><td>{{i.shortName}} {{i.name}}</td><td *ngIf="i.totalMembers===0"></td><td *ngIf="i.totalMembers > 0">{{i.totalMembers}}</td><td *ngIf="i.attendancePercent === 'NaN'"></td><td *ngIf="i.attendancePercent !== 'NaN'">{{i.attendancePercent}}</td>
        </tr>
        <tr style="border-top:1px solid lightgrey;padding-top:5px;font-weight:bold;">
          <td></td><td>Totalt:</td><td>{{response[idx]?.total.totalAmount}}</td><td>{{response[idx]?.total.totalPercent}}</td>
        </tr>
      </table>
    </div>
  </span>
</div>
</div>

</div>


<!--div *ngFor="let o of response;index as i">
  {{o[i].totalMedlemar}}
</div-->
